import * as React from 'react';
import { CarouselItem } from 'react-bootstrap';
import type { PropsWithChildren } from 'react';
import * as styles from '../css/feedback-carousel-item.css';
import { classNames } from '../utils';

interface Props {
    className?: string;
}

const FeedbackCarouselItem = ({ children, className, ...rest }: PropsWithChildren<Props>) => (
    <CarouselItem className={classNames(className, styles.root)} {...rest}>
        {children}
    </CarouselItem>
);

export default FeedbackCarouselItem;
